import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetsStore } from '@coach-bot/data-access/shared';
import {
  IconDefinition,
  faBook,
  faCalculator,
  faCheck,
  faFlask,
  faMonument
} from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject } from 'rxjs';

interface Subject {
  name: string;
  icon: IconDefinition;
}

@Component({
  selector: 'st-subject-selector',
  templateUrl: './subject-selector.component.html',
  styleUrls: ['./subject-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubjectSelectorComponent {
  @Input() selectedSubject: string;
  @Output() subjectSelected = new EventEmitter<string>();

  assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;

  icons = {
    faBook: faBook,
    faCalculator: faCalculator,
    faCheck: faCheck,
    faFlask: faFlask,
    faMonument: faMonument
  };
  subjects: Subject[] = [
    {
      name: 'Math',
      icon: this.icons.faCalculator,
    },
    {
      name: 'Science',
      icon: this.icons.faFlask,
    },
    {
      name: 'History',
      icon: this.icons.faMonument,
    },
    {
      name: 'English',
      icon: this.icons.faBook,
    },
  ];

  constructor(private assetsStore: AssetsStore) {
  }

  selectSubject(subject: string): void {
    this.subjectSelected.emit(subject);
  }
}
